import { defineComponent as _defineComponent } from 'vue'
import CardContainer from '@/components/card-container.vue';
import { ImageLoader } from '@tencent/wphk-components-content-loader';
import ShareIcon from './share-icon.vue';
import { i18n } from '@/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'merchant-info',
  props: {
    name: null,
    logo: null
  },
  setup(__props: any) {


const ariaShareText = i18n('立即share畀朋友');

return { __sfc: true,ariaShareText, CardContainer, ImageLoader, ShareIcon }
}

})